import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
export var context = createContext({
  opened: false,
  control: void 0,
  state: 'init',
  toggle: function toggle() {},
  registerControl: function registerControl() {},
  content: {
    current: null
  },
  registerContent: function registerContent() {}
});
export function useDropdown() {
  return useContext(context);
}
function useMouseOver(node, handlerIn, handlerOut) {
  useEffect(function () {
    if (!node) {
      return;
    }
    node.addEventListener('mouseenter', handlerIn);
    node.addEventListener('mouseleave', handlerOut);
    return function () {
      node.removeEventListener('mouseenter', handlerIn);
      node.removeEventListener('mouseleave', handlerOut);
    };
  }, [node, handlerIn, handlerOut]);
}
export function useDropdownHover() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? 0 : _ref$open,
    _ref$close = _ref.close,
    close = _ref$close === void 0 ? 0 : _ref$close,
    _ref$contentHoverPres = _ref.contentHoverPreserve,
    contentHoverPreserve = _ref$contentHoverPres === void 0 ? true : _ref$contentHoverPres;
  var _useDropdown = useDropdown(),
    toggle = _useDropdown.toggle,
    opened = _useDropdown.opened,
    registerControl = _useDropdown.registerControl,
    content = _useDropdown.content;
  var control = useRef(null);
  var openTimer = useRef();
  var closeTimer = useRef();
  var triggerOpen = useCallback(function () {
    if (closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
    openTimer.current = setTimeout(function () {
      if (!opened) {
        toggle();
      }
    }, open);
  }, [open, opened, toggle]);
  var triggerClose = useCallback(function () {
    if (openTimer.current) {
      clearTimeout(openTimer.current);
    }
    closeTimer.current = setTimeout(function () {
      if (opened) {
        toggle();
      }
    }, close);
  }, [close, opened, toggle]);
  var handleContentMouseIn = useCallback(function () {
    if (contentHoverPreserve && closeTimer.current) {
      clearTimeout(closeTimer.current);
    }
  }, [contentHoverPreserve]);
  var handleContentMouseOut = useCallback(function () {
    if (contentHoverPreserve) {
      triggerClose();
    }
  }, [contentHoverPreserve, triggerClose]);
  useEffect(function () {
    if (!control.current) {
      return;
    }
    registerControl(control.current);
  }, [registerControl, control]);
  useMouseOver(control.current, triggerOpen, triggerClose);
  useMouseOver(content.current, handleContentMouseIn, handleContentMouseOut);
  return {
    opened: opened,
    control: control
  };
}
export function useIsIos() {
  var _useState = useState(typeof window === 'undefined' ? false : /iPhone;/gi.test(window.navigator.userAgent)),
    _useState2 = _slicedToArray(_useState, 2),
    isSafariMobile = _useState2[0],
    setIsSafariMobile = _useState2[1];
  useEffect(function () {
    return setIsSafariMobile(/iPhone;/gi.test(window.navigator.userAgent));
  }, []);
  return isSafariMobile;
}